
const divLinks = document.querySelectorAll('.div-link');
divLinks.forEach(function(link) {
   link.addEventListener('click',function(e) {
       e.preventDefault();
       const divLink = e.target.closest('.div-link');
       const link = divLink.querySelector('.card-click');
       const target = link.target ? link.target : '_self';
       window.open(link.href, target);
   }) ;
});


const dropDowns = document.querySelectorAll(".ingred-list");
if(dropDowns) {
    dropDowns.forEach(ddParent => {
        const dropDown = ddParent.querySelector('.dropbtn');
        if(dropDown) {
            const id = dropDown.dataset.id;
            ddParent.addEventListener('click',function(e) {
                dropDown.classList.toggle('active');
                const ddContent = document.querySelector(`#${id}`);
                ddContent.classList.toggle('show');
            })
        }

    });
}
